export const contactTranslations = {
    en: {
      title: 'Contact',
      email: 'Email',
      address: 'Address',
      addressText: '202, 2nd floor, 102, Haengun 1-gil, Gwanak-gu, Seoul, Republic of Korea (Genetic Mutation)',
    },
    ko: {
      title: '연락처',
      email: '이메일',
      address: '주소',
      addressText: '서울특별시 관악구 행운1길 102 2층 202호 (변이원성물질)',
    },
    ja: {
      title: 'お問い合わせ',
      email: 'メール',
      address: '住所',
      addressText: '202, 2nd floor, 102, Haengun 1-gil, Gwanak-gu, Seoul, Republic of Korea (遺伝子変異)',
    },
    zh: {
      title: '联系方式',
      email: '电子邮件',
      address: '地址',
      addressText: '202, 2nd floor, 102, Haengun 1-gil, Gwanak-gu, Seoul, Republic of Korea (基因突变)',
    },
  };